import { nortadaLogger } from '../logger';

interface Payload {
  error: string;
}

export interface State {
  currentPage: STEP;
  payload?: Payload;
}

export type Action = { type: STEP; payload?: Payload };

export enum STEP {
  'SEARCH' = 'SEARCH',
  'RESULTS' = 'RESULTS'
}

export const initialState = {
  currentPage: STEP.SEARCH
};

export function searchByOperationIdReducer(state: State, action: Action): State {
  switch (action.type) {
    case STEP.SEARCH:
      return {
        currentPage: STEP.SEARCH,
        payload: action.payload
      };
    case STEP.RESULTS:
      return {
        currentPage: STEP.RESULTS,
        payload: action.payload
      };
    default:
      throw nortadaLogger.critical(`${action.type} action is not handled`);
  }
}
